<template>
  <div class="bbp-tooltip">
    <div class="bbp-tooltip__item">
      <span class="bbp-tooltip__text">{{textToolTip}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPTooltip',
  props: ['textToolTip']
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbp-tooltip {
  @include global-font;
  position: relative;
  display: inline-block;
  border-bottom: 1px solid black;
  pointer-events: none;

  &__item {
    position: absolute;
    z-index: 5;
    padding: 4px 5px;
    background: $color-black;
    opacity: 0.5;
    top: 33px;
    right: 4px;
    text-transform: capitalize;
    border-radius: 3px;

    &:after {
      content: "";
      position: absolute;
      bottom: 100%;
      right: 5px;
      border-width: 4px;
      border-style: solid;
      border-color: transparent transparent $color-black transparent;
    }
  }
  &__text {
    font-weight: 500;
    font-size: 11px;
    line-height: 120.34%;
    color: $color-white;
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTooltip/BBPTooltip.vue